import { registerGroup, registerRect, registerSymbol, registerText } from "@visactor/vrender-kits";

export function loadSliderComponent() {
    registerGroup(), registerText(), registerRect(), registerSymbol();
}
//# sourceMappingURL=register.js.map
